import { useState } from "react";
import { ServiceModalProps } from "../types/Props";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icons } from '../utils/icons';
import { useLanguage } from "../contexts/LanguageContext";
import { markerIcons } from '../utils/serviceCategoryUtils';

const DescriptionPreview = ({ text, maxLength = 300 }: { text: string; maxLength?: number }) => {
  const { translations } = useLanguage();
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isLong = text.length > maxLength;
  const preview = isLong ? text.slice(0, maxLength) + "..." : text;

  return (
    <div>
      <p>
        {expanded || !isLong ? text : preview}
        {isLong && (
          <button
            className="read-more-button"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? translations.servicemap.showless : translations.servicemap.showmore}
          </button>
        )}
      </p>
    </div>
  );
};

const ServiceModal = ({ service, onClose }: ServiceModalProps) => {
  const { translations } = useLanguage();
    
  return (
    <div className="modal-container">
      <div className="modal-content-full">
        <div className="top-bar-modal">
          <h2>{service.name}</h2>
          <button className='modal-close' onClick={onClose}>X</button>
        </div>
        <div className="modal-content">
          <div className="service-logo-wrapper">
            {service.logo_url && <img src={service.logo_url} alt='Service Logo' className="service-logo"/>}
          </div>
          <div className="service-card-wrapper">
            <div className="service-card-icons">
              <img src={markerIcons[service.category]} width={54} height={54} alt='Category Icon' className="category-icon" />
              <img src="/bikeland_welcomecyclist_logo.avif" width={42} height={42} alt="Certificate" className="certificate-icon" />
            </div>
            <div className="card">
              <DescriptionPreview text={service.description} />
              <ul className="service-info-list">
                <li>
                  <FontAwesomeIcon icon={icons.locationDot} className="listIcon" />
                  {service.address}
                </li>
                <li>
                  <FontAwesomeIcon icon={icons.phone} className="listIcon"/>
                  <a href={`tel:${service.phone}`} className="phonelink">{service.phone}</a>
                </li>
                <li>
                  <a href={service.url} target="_blank" rel="noreferrer" className="service-website-button">
                    {translations.servicemap.visitwebsite} <FontAwesomeIcon icon={icons.link} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
  
export default ServiceModal;